export default function sectionTitle(context, content, key) {
  const { compose } = context;
  return <h2 key={key}>{content._ || compose(context, content.$$)}</h2>;
}
